import { RightSectionTableTranslations } from "./types";

export const deTranslations: RightSectionTableTranslations = {
    noRecord: "keine Aufzeichnung vorhanden",
    actions: "Handlungen der Studierenden",
    percentage: "Prozent %"
};